import { Address } from "./address";

export class IRepairFacility {
	id: string;
	facilityName: string;
	emailAddress: string;
	address: Address;
	phone: string;
	laborManual: string;
	laborRate?: number;
	laborTaxRate?: number;
	partTaxRate?: number;
	isPreferred: boolean;
	isPublic: boolean;
	preferredPaymentMethod: string;
	webSiteUrl: string;
}

// Describes a repair facility.
export class RepairFacility implements IRepairFacility {

	constructor() {
		this.address = new Address();
	}

	// The repair facility ID.
	id: string;
	// The repair facility name.
	facilityName: string;
	// The repair facility's email address.
	emailAddress: string;
	// The repair facility's physical address.
	address: Address;
	// The repair facility's phone number.
	phone: string;
	// The labor manual used by the repair facility.
	laborManual: string;
	// The labor rate for the repair facility.
	laborRate?: number;
	// The labor tax rate for the repair facility.
	laborTaxRate?: number;
	// The part tax rate for the repair facility.
	partTaxRate?: number;
	// Indicates if this is a preferred repair facility.
	isPreferred: boolean;
	// Indicates if this is a public repair facility.
	isPublic: boolean;
	// The preferred payment method for the repair facility.
	preferredPaymentMethod: string;
	// The URL of the repair facility's website.
	webSiteUrl: string;
}